import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import Modal, { ModalProps } from './Modal'

export const MODAL_DISPLAY_TIME = 3000
export const MODAL_TRANSITION_TIME = 300
export const MODAL_ANIMATION_TIME = MODAL_DISPLAY_TIME + MODAL_TRANSITION_TIME

/**
 * アニメーションするモーダル(スライド/透過)
 */
const AnimationModal: React.FC<AnimationModalProps> = (props) => {
  const [disp, setDisp] = useState(false)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    setDisp(props.on)
    // transitionをさせるためにprops.onがfalseになってから0.3s後にModalをクローズする
    const updateOpen: () => Promise<void> = async () => {
      await new Promise((resolve) => setTimeout(resolve, MODAL_TRANSITION_TIME))
      setOpen(props.on)
    }
    updateOpen()
  }, [props.on])

  return (
    <Modal
      on={props.on || open}
      type={props.type}
      scrollLock={props.scrollLock}
      greyBack={props.greyBack}
      manualTop={props.manualTop}
      manualBottom={props.manualBottom}
      cursorPenetrate={props.cursorPenetrate}
      greyBackClose={props.greyBackClose}
      closeFunction={props.closeFunction}
    >
      <InformationArea disp={disp} animationType={props.animationType}>
        {props.children}
      </InformationArea>
    </Modal>
  )
}

type AnimationModalProps = ModalProps & {
  children: React.ReactNode
  animationType: 'transparent' | 'slide'
  cursorPenetrate?: boolean
  closeFunction?: () => void
  greyBackClose?: boolean
}

const InformationArea = styled.div<{
  disp: boolean
  animationType: string
}>`
  ${(props): string =>
    props.animationType === 'transparent' && props.disp
      ? 'opacity: 1;'
      : props.animationType === 'transparent' && !props.disp
      ? 'opacity: 0;'
      : props.animationType === 'slide' && props.disp
      ? 'transform: translateY(0px);'
      : 'transform: translateY(-200px);'};
  transition: all ${MODAL_TRANSITION_TIME / 1000}s;
`

export default React.memo<AnimationModalProps>(AnimationModal)
